import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fe8e8ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "nfo" }
const _hoisted_3 = { class: "nfo-box" }
const _hoisted_4 = { class: "nfo-ok" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.szgxqm'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_cell_group, { inset: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: $setup.sign,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => (($setup.sign) = $event)),
                $setup.changeText
              ],
              rows: "5",
              autosize: "",
              type: "textarea",
              maxlength: "30",
              placeholder: $setup.t('me.qsrgxqm'),
              "show-word-limit": ""
            }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" <van-field v-model=\"name\" clearable placeholder=\"请输入昵称\" /> ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.ok()))
        }, _toDisplayString(_ctx.$t('im.wanc')), 1 /* TEXT */)
      ])
    ])
  ]))
}